import {env} from "../env/env";

export function getImagePath(key: string, isOoNative: boolean = true) {
  if (key.indexOf('imageservice') > -1) {
    return 'https://musthavemenus.com' + key;
  }
  const s3 = isOoNative ? env.s3Path : env.mhmS3Path;
  return key.indexOf('https') > -1 ? key : `${s3}${key}`;
}
